export default {
  title: '积分商品',
  addGift: '添加礼品',
  giftInfo: '礼品信息',
  giftInfoPlaceholder: '请输入关键词搜索',
  category: '分类',
  publishStatus: '状态',
  batchSetStock: '批量设置库存',
  batchOnline: '批量上架',
  batchOffline: '批量下架',
  batchOnlineConfirm: '确定批量上架商品？',
  batchOfflineConfirm: '确定批量下架商品？',
  batchSetStockTitle: '批量设置库存',
  batchSetStockPlaceholder: '请输入库存数量',
  batchSetStockTip: '将对所选 {count} 件礼品统一设置库存',
  selectFirstTip: '请先勾选商品',
  exchangePrice: '兑换价格',
  exchangedQty: '已兑换数量',
  stock: '库存',
  status: '状态',
  online: '已上架',
  offline: '已下架',
  createTime: '创建时间',
  edit: '编辑',
  delete: '删除',
  deleteConfirm: '删除后不可恢复，确定要删除吗？',
  editStock: '编辑库存',
  stockRequired: '请输入库存数量',
  stepSelectGift: '选择礼品',
  stepGiftConfig: '礼品设置',
  addGiftTitle: '添加礼品',
  editGiftTitle: '编辑礼品',
  giftLibCategory: '礼品库分类',
  pricePerYuan: '价格/元',
  giftType: '礼品类型',
  giftTypeAll: '全部',
  giftTypePhysical: '实物礼品',
  giftTypeVirtual: '虚拟礼品',
  stockCount: '库存数',
  selectAction: '选择',
  giftSnLabel: '编号',
  giftNo: '礼品编号',
  selectedGift: '已选礼品',
  marketPrice: '市场价格',
  exchangePriceLabel: '可兑换价格',
  pointsPay: '积分支付',
  exchangeQty: '可兑换数量',
  specInfo: '规格信息',
  specStock: '规格库存',
  exchangePriceCol: '兑换价格',
  pointsUnit: '积分',
  inputPlaceholder: '请输入',
  virtualExchange: '虚拟兑换量',
  virtualExchangePlaceholder: '请输入虚拟兑换量',
  listSort: '列表排序',
  listSortPlaceholder: '请输入',
  publish: '立即上架',
  categoryRequired: '请选择分类',
  exchangePriceRequired: '请选择可兑换价格',
  specStockRequired: '请填写规格库存',
  specPriceRequired: '请填写兑换价格',
};
